import { parseISO } from "date-fns";
import { formatDate } from "../../shared/dateUtils";

/**
 * Checks if a booking is allowed for juniors.
 * Returns false if:
 * 1. It's a weekday (Monday to Friday) AND
 * 2. The time is between 16:00 and 19:00 AND
 * 3. The court is B11
 * Otherwise returns true (booking is allowed)
 */
export function isBookingAllowedForJuniors(
  filterDate: Date,
  slotStartTime: string,
  courtName: string,
  slotHasCoach: boolean
): boolean {
  // Check if booking start time is less than 5 minutes away or in the past
  const now = new Date();
  const bookingDateTime = new Date(
    `${formatDate(filterDate, "yyyy-MM-dd")}T${slotStartTime}`
  );
  const fiveMinutesFromNow = new Date(now.getTime() + 5 * 60 * 1000);

  // If booking time is less than 5 minutes away or in the past, allow booking
  if (bookingDateTime <= fiveMinutesFromNow) {
    return true;
  }

  const isWeekday = (date: Date) => {
    const day = date.getDay();
    return day >= 1 && day <= 5;
  };

  const isBetween16And19 = (date: Date) => {
    const hour = date.getHours();
    return hour >= 16 && hour < 19;
  };

  const checkDate = (date: string) => {
    const parsedDate = parseISO(date);
    return isWeekday(parsedDate) && isBetween16And19(parsedDate);
  };

  const isOutsideJuniorTime = checkDate(
    formatDate(filterDate, "yyyy-MM-dd") + "T" + slotStartTime
  );

  const isCourtB11 = courtName === "B15";

  return !isOutsideJuniorTime && isCourtB11 && slotHasCoach;
}

export function isBookingAllowedForJuniorPlayRight(
  filterDate: Date,
  slotStartTime: string,
  isAvailable: boolean
): boolean {
  if (isAvailable) {
    return true;
  }
  // Check if booking start time is less than 5 minutes away or in the past
  const now = new Date();
  const bookingDateTime = new Date(
    `${formatDate(filterDate, "yyyy-MM-dd")}T${slotStartTime}`
  );

  // If booking time is less than 5 minutes away or in the past, allow booking
  if (bookingDateTime <= now) {
    return true;
  }
  return false;
}
